import Appsignal from '@appsignal/javascript'

export default new Appsignal({
  // set key only when active; missing key enables development mode
  key: process.env.REACT_APP_APPSIGNAL_KEY,
  // revision is needed for sourcemaps
  revision: process.env.REACT_APP_REVISION,
})
